export enum AlloyMode {
  EVAL = "Evaluate",
  DOCV = "Document Verify"
}
